<template>
  <!-- Content -->
  <CRow>
    <CCol col="12">
      <CForm>
        <CModal
          title="Remover"
          color="danger"
          :show.sync="removeModal.show"
          :centered="true"
        >
          Ao confirmar essa ação o item não poderá ser recuperado, tem certeza
          que desejar continuar?
          <template #footer>
            <button
              type="button"
              class="btn btn-secondary"
              @click="toggleModal"
            >
              Cancelar
            </button>
            <button type="button" class="btn btn-danger" @click="forceDelete">
              Remover
            </button>
          </template>
        </CModal>

        <!-- Back -->
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <CButton color="danger ml-4" @click="toggleModal">
                Excluir Permanentemente
              </CButton>
              <a class="ml-4" href="javascript:void(0)" @click="$router.go(-1)"
                ><CIcon name="cil-arrow-left" class="mr-2" />Voltar</a
              >
            </div>
          </CCol>
        </CRow>

        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4>Trabalhe Conosco</h4>
          </CCardHeader>
        </CCard>

        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">
              <CIcon name="cil-justify-center" class="mb-1 mr-2" />
              Informações
            </h5>
          </CCardHeader>

          <CCardBody class="pb-0">
            <CRow>
              <CCol lg="12" md="12" sm="12">
                <CRow>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Data de envio</b><br />
                      {{ contact.date }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Nome</b><br />
                      {{ contact.name }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>E-mail</b><br />
                      {{ contact.email }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Telefone</b><br />
                      {{ contact.phone }}
                    </p>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12" md="12" sm="12">
                <CRow>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>CPF</b><br />
                      {{ contact.document }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Data de Nascimento</b><br />
                      {{ contact.birthday }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Estado</b><br />
                      {{ contact.uf }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Cidade</b><br />
                      {{ contact.city }}
                    </p>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol lg="12" md="12" sm="12">
                    <CRow>
                      <CCol lg="3" md="3" sm="3">
                        <p>
                          <b>Área de Interesse</b><br />
                          {{ contact.area_of_interest }}
                        </p>
                      </CCol>
                      <CCol lg="3" md="3" sm="3">
                        <p>
                          <b>Nível de escolaridade</b><br />
                          {{ contact.education_level }}
                        </p>
                      </CCol>
                      <CCol lg="3" md="3" sm="3">
                        <p>
                          <b>Nível de Formação</b><br />
                          {{ contact.training_level }}
                        </p>
                      </CCol>
                      <CCol lg="3" md="3" sm="3">
                        <p>
                          <b>Currículo</b><br />
                          <a
                            :href="contact.link"
                            style="color: #7b1716 !important"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              role="img"
                              class="c-sidebar-nav-icon"
                            >
                              <rect
                                width="288"
                                height="32"
                                x="112"
                                y="152"
                                fill="var(--ci-primary-color, currentColor)"
                                class="ci-primary"
                              ></rect>
                              <rect
                                width="288"
                                height="32"
                                x="112"
                                y="240"
                                fill="var(--ci-primary-color, currentColor)"
                                class="ci-primary"
                              ></rect>
                              <rect
                                width="152"
                                height="32"
                                x="112"
                                y="328"
                                fill="var(--ci-primary-color, currentColor)"
                                class="ci-primary"
                              ></rect>
                              <path
                                fill="var(--ci-primary-color, currentColor)"
                                d="M480,48H32V464H480ZM448,432H64V80H448Z"
                                class="ci-primary"
                              ></path>
                            </svg>
                            Baixar currículo</a
                          >
                        </p>
                      </CCol>
                    </CRow>

                    <CRow>
                      <CCol md="12" lg="12">
                        <p>
                          <b>Mensagem</b><br />
                          {{ contact.message }}
                        </p>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">
              <CIcon name="cil-justify-center" class="mb-1 mr-2" />
              Dados restritos
            </h5>
          </CCardHeader>

          <CCardBody class="pb-0">
            <CRow>
              <CCol lg="3" md="3" sm="3">
                <p>
                  <b>IP:</b><br />
                  {{ contact.ip }}
                </p>
              </CCol>
              <CCol lg="3" md="3" sm="3">
                <p>
                  <b>Data aceite dos termos:</b><br />
                  {{ contact.accepted_at }}
                </p>
              </CCol>
              <CCol lg="3" md="3" sm="3">
                <p>
                  <b>Navegador:</b><br />
                  {{ contact.browser }}
                </p>
              </CCol>
              <CCol lg="3" md="3" sm="3">
                <p>
                  <b>Sistema operacional:</b><br />
                  {{ contact.os }}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
import moment from 'moment'

// Services
import Service from '@/services/work-with-us.service'

export default {
  metaInfo: {
    title: 'Trabalhe Conosco',
    titleTemplate: ' %s - Manager - Intelli'
  },

  data() {
    return {
      contact: {
        date: '',
        name: '',
        phone: '',
        email: '',
        document: '',
        birthday: '',
        state: '',
        city: '',
        area_of_interest: '',
        education_level: '',
        training_level: '',
        link: '',
        message: '',
        accepted: '',
        ip: '',
        browser: '',
        os: ''
      },
      removeModal: {
        show: false,
        title: '',
        message: '',
        color: ''
      }
    }
  },

  async created() {
    if (this.$route.params.id) {
      const response = await Service.show(this.$route.params.id)

      this.contact = {
        ...response.data,
        area_of_interest: response.data.interest
          ? response.data.interest.name
          : '',
        education_level: response.data.education_level
          ? response.data.education_level.name
          : '',
        training_level: response.data.training_level
          ? response.data.training_level.name
          : '',
        document: response.data.documentFormated,
        link:
          response.data.file &&
          response.data.file.length > 0 &&
          response.data.file[0].download,
        birthday: moment(response.data.birthday).format('DD/MM/YYYY'),
        date: moment(response.data.created_at).format('DD/MM/YYYY'),
        accepted_at: moment(response.data.accepted_at).format('DD/MM/YYYY')
      }
    }
  },
  methods: {
    toggleModal() {
      this.removeModal.show = !this.removeModal.show
    },

    async forceDelete() {
      this.toggleModal()
      const response = await Service.forceDelete(this.$route.params.id, {
        type: 'Contato',
        name: this.contact.name
      })

      if (response && response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'O currículo foi excluído conforme a LGPD'
        })
        setTimeout(() => {
          this.processing = false
          this.$router.push(
            this.$route.matched[this.$route.matched.length - 2].path
          )
        }, 500)
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Não é possivel excluir o currículo'
        })
      }
    }
  }
}
</script>
